export default "__VITE_ASSET__ioDhnpml__"